import { styled } from 'styled-components'
import { Divider } from '@mui/material'

export const NavDivider = styled(Divider)`
  margin-block: 28px;
  border-color: ${({ theme }) => theme.colors.grayMedium};
`
